app.controller('mainController', function($http, $scope, $stateParams, $location, dataService, $rootScope, appService, $q, $timeout, $window, appActivity, httpPendingRequests, $controller) {
	
	$controller('userDefinedMainController', {$scope: $scope, appActivity: appActivity, $stateParams: $stateParams});
	
	//--------FUNCTION DECLARATION START---------------//
	
	//listen to invalid request error on ajax calls for error reporting
	$rootScope.$on('invalid_request_in_response', function(event, invalid_request_object) {
		
		var error_code = typeof(invalid_request_object.response.data) != 'undefined' && typeof(invalid_request_object.response.data.error_code) != 'undefined' ? invalid_request_object.response.data.error_code : '';
		var error_code_text = error_code != '' ? '&nbsp;(Status Code : ' + error_code + ')': '';
		
		var logData = {};
		logData.request_url = invalid_request_object.request_url;
		logData.request_params = invalid_request_object.request_params;
		logData.logGroup = 'INVALID_REQUEST';
		logData.logType = 'error';
		logData.errorCode = error_code ;
		logData.logMessage = typeof(invalid_request_object.response.data.message) != 'undefined' ? invalid_request_object.response.data.message : '';
		
		var title = typeof(invalid_request_object.response.data.title) != 'undefined' ? invalid_request_object.response.data.title : 'INVALID REQUEST';
		var message = typeof(invalid_request_object.response.data.message) != 'undefined' ? invalid_request_object.response.data.message : 'Sorry, that was an invalid request.';
		var avoid_report_issue = typeof(invalid_request_object.response.data.avoid_report_issue) != 'undefined' ? invalid_request_object.response.data.avoid_report_issue : false;
		
		var error_html	= '<div class="modal-dialog">'+
      						'<div class="modal-content">'+
      						'';
		error_html		+= '<div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><b>'+title+'</b>' + error_code_text + '</div>';
		error_html 		+= '<div class="modal-body"><p>'+message+'</p>';
		if(!avoid_report_issue) {
			error_html 		+= '<div><a class="runtime-reload" href="javascript:void(0);">Click here</a> to reload the dashboard.</div></div>';
			error_html 		+= '<div class="modal-footer help-block report-error"><a class="btn btn-sm btn-primary" href="javascript:void(0);">Report this issue</a></div>';
		} else {
			error_html 		+= '</div><div class="modal-footer"></div>';
		}
		error_html		+= '</div></div>';

		$('#runTimeError').modal('hide');// if you don't want to lose the reference to previous backdrop
		$('#runTimeError').data('bs.modal',null); // this clears the BS modal data

		$('#runTimeError').html(error_html);
		$('#runTimeError .runtime-reload').click(function(){$window.location.href = app_redirect_base_url;})
		$('#runTimeError .report-error a:eq(0)').click(function(){appActivity.reportError(logData, $('#runTimeError .report-error'));})
		// $('#runTimeError').show();
		$('#runTimeError').modal({
                        backdrop: 'static',
                        keyboard: true, 
                        show: true
                });

		//log error
		appActivity.logActivity(logData);
		
	});
	
	//to change the URL to new app state
	$scope.changeToNewState = function()
	{
		var new_page =  $scope.appState.page;
		var new_state = {};
		$.each($scope.appState, function(key, value)
		{
			//if page filters, add the elements to the URL
			if(key == 'page_filters')
			{
				$.each(value, function(filter_key, filter_value)
				{
					new_state[filter_key] = filter_value;
				});
				
				//continue;
				return true;
			}	
			
			new_state[key] = value;
		});
		
		//change URL
		$location.path('/' + new_page).search(new_state);
	}
	
	$scope.InitiateNewStateChange = function()
	{
		//if initiated by browser, reset 
		if($scope.locationChangeInitiator == 'browser')
		{
			//reset locationChangeInitiator flag
			$scope.locationChangeInitiator = '';
		}
		
		//cancel all pending requests
		$scope.cancelAllRequests();
		
		//copy the state to rootScope to fetch pageConfig
		$rootScope.appState = $scope.appState;
		$scope.changeToNewState();
		$scope.updateBreadCrumbs();
                $scope.$broadcast('changeSidebarEvent', $scope.appState);
	}
	
	//to update breadcrumb
	$scope.updateBreadCrumbs = function() 
	{
		//find page
		var pageText =  angular.copy($location.$$path);
		pageText 	 = pageText.replace('/', '');
		
		//find submenu
		var submenuText = '';
		var submenu_key = '';
		var currentPageDetails = (typeof ($scope.navigation[pageText]) != 'undefined' && typeof ($scope.navigation[pageText].submenu) != 'undefined') ? $scope.navigation[pageText] : null; 
		if(currentPageDetails !== null)
		{
			$.each(currentPageDetails.submenu, function(key, submenu)
			{
				if(typeof (submenu.params) != 'undefined' && typeof (submenu.params.selectedKey) != 'undefined')
				{	
					var submenuKey = submenu.params.selectedKey;
					if(typeof($location.$$search[submenuKey]) != 'undefined' && $location.$$search[submenuKey] == submenu.params[submenuKey])
					{
						submenuText = submenu.label;
						submenu_key = submenu.params[submenuKey];
						return false;
					}	
				}
			});
		}	
		
		//find filters
		var selectedFilters = [];
		var leftMenuFilters = {};
		var filterTitles = {};
		var ignoreSelectedFilters = {};

		angular.forEach($scope.filters, function(value, key) 
		{
			//use specific experiance labels if defined in the filter
			if(typeof value.experiance_label != 'undefined' && submenu_key != '')
			{
				filterTitles[key] = typeof value.experiance_label[submenu_key] != 'undefined'?value.experiance_label[submenu_key]:value.label;
			}
			else
			{
				filterTitles[key] = value.label;
			}
		});

		$.each($scope.appState, function(stateKey, stateValue)
		{
			if(typeof($scope.filters[stateKey]) != 'undefined')
			{
				var filterCollection = $scope.filters[stateKey].value;

				var filterType = typeof($scope.filters[stateKey].type) != 'undefined' ? $scope.filters[stateKey].type : '';
				
				if(stateValue != '' && typeof(filterCollection[stateValue]) != 'undefined')
				{
					if(typeof(filterCollection[stateValue].value) != 'undefined')
					{	
						var selectedFilter 		= filterCollection[stateValue].value;
						var selectedFilterValue = (typeof ($scope.appState[stateKey + '_value']) == 'undefined') ? '' : $scope.appState[stateKey + '_value'];
						var selectedFilterSupersets = (typeof(filterCollection['superset']) != 'undefined')?filterCollection['superset'].value:[];
						var selectedFilterDisplayLink = selectedFilter.length == 1&&selectedFilterSupersets.length == 1?false:true;
						$.each(selectedFilter, function(filterKey, filterValue)
						{
							if(selectedFilterValue == filterValue.id)
							{
								var filterTitle = filterTitles[stateKey]!=''&&typeof filterTitles[stateKey]!='undefined'?filterTitles[stateKey]:'Filter';
								selectedFilters.push({'label' : filterValue.label, 'key' : stateKey, 'template' : $scope.filters[stateKey].template, 'display_link': selectedFilterDisplayLink, 'visibility':$scope.filters[stateKey].visibility});
								leftMenuFilters[stateKey] = {'label' : filterValue.label, 'title': filterTitle,  'icon' : $scope.filters[stateKey].icon, 'template' : $scope.filters[stateKey].template, 'display_link': selectedFilterDisplayLink, 'visibility':$scope.filters[stateKey].visibility};
								return false;
							}	
						});
					}
					else
					{
						var currentFilterObj = angular.copy(filterCollection[stateValue]);
						currentFilterObj.display_link = false;
						currentFilterObj.visibility = $scope.filters[stateKey].visibility;
						currentFilterObj.title = filterTitles[stateKey];
						currentFilterObj.icon = $scope.filters[stateKey].icon
						
						selectedFilters.push(currentFilterObj);
						leftMenuFilters[stateKey] = angular.copy(currentFilterObj);
					}	
				}
				
				//find selected value from superset
				if(typeof(filterCollection['superset']) != 'undefined' && typeof($scope.appState[stateKey + '_superset_value']) != 'undefined')
				{
					var selectedFilter 		= filterCollection['superset'].value;
					var selectedFilterValue = $scope.appState[stateKey + '_superset_value'];
					var selectedFilterDisplayLink = selectedFilter.length == 1?false:true;

					$.each(selectedFilter, function(filterKey, filterValue)
					{
						if(selectedFilterValue == filterValue.id)
						{
							selectedFilters.push({'label' : filterValue.label, 'key' : stateKey, 'template' : $scope.filters[stateKey].template, 'display_link': selectedFilterDisplayLink, 'visibility':$scope.filters[stateKey].visibility});
							if(selectedFilterValue != '')
							{
								var filterTitle = filterTitles[stateKey]!=''&&typeof filterTitles[stateKey]!='undefined'?filterTitles[stateKey]:'Filter';
								leftMenuFilters[stateKey] = {'label' : filterValue.label, 'title': filterTitle, 'icon' : $scope.filters[stateKey].icon, 'template' : $scope.filters[stateKey].template, 'display_link': selectedFilterDisplayLink, 'visibility':$scope.filters[stateKey].visibility};
							}
							return false;
						}
					});
				}	

				if(filterType == 'custom')
				{
					var res_survy = false;
					if(typeof(filterCollection['restricted_surveys']) != 'undefined' && filterCollection['restricted_surveys'] != '')
					{
						if(typeof($scope.appState['submenu_key']) != 'undefined' && $scope.appState['submenu_key'] != '')
						{
							$.each(filterCollection['restricted_surveys'], function(filterKey, filterValue)
							{
								if(filterValue == $scope.appState['submenu_key'])
								{
									res_survy = true;
									return false;
								}
							});
						}
					}

					if(res_survy === false && typeof($scope.appState[stateKey]) != 'undefined' && $scope.appState[stateKey] != '')
					{
						selectedFilters.push({'label' : $scope.appState[stateKey], 'key' : stateKey});
						customFilterSelected = true;
						if(typeof($scope.filters[stateKey]) != 'undefined')
			    		{
			    			if(typeof($scope.filters[stateKey]['remove_selected_filter']) != 'undefined')
			    			{
			    				ignoreSelectedFilters = $scope.filters[stateKey]['remove_selected_filter'];
			    			}
			    		}
					}
					
					if(res_survy === false)
					{
						var filterTitle = filterTitles[stateKey]!=''&&typeof filterTitles[stateKey]!='undefined'?filterTitles[stateKey]:'Filter';
						var filterVal = filterCollection.value[0];
						leftMenuFilters[stateKey] = {'label' : filterTitle, 'title': filterTitle, 'value' : filterVal, 'icon' : $scope.filters[stateKey].icon, 'visibility':$scope.filters[stateKey].visibility, 'no_popup' : true};
					}
					else
					{
						$timeout(function() {
							$scope.appState['custom_filter'] = '';
							$scope.$apply();
				        }, 10);
					}
				}
			}	
		});

		var pageDetails = typeof ($scope.navigation[pageText]) != 'undefined' ? $scope.navigation[pageText]:{}

		//Remove any filters which needs to be hidden for the page
		var hide_filters = typeof(pageDetails.hide_filters) != 'undefined' ? pageDetails.hide_filters : [];

		var staticSubMenuPage = typeof (pageDetails.static_submenu) != 'undefined' ? pageDetails.static_submenu : [];

		//Remove any filters which needs to be hidden for the page based on submenu
		var submenu_hide_filters = (typeof(staticSubMenuPage[$scope.appState['submenu_key']]) != 'undefined' && typeof(staticSubMenuPage[$scope.appState['submenu_key']].hide_filters) != 'undefined') ? staticSubMenuPage[$scope.appState['submenu_key']].hide_filters : [];

		//remove the hidden filters from the bradcrumbs
		var allowedSelectedFilters = {};
		$.each(selectedFilters, function(i, item){
			//If not in the array
			if($.inArray(item.key, hide_filters) == -1 && $.inArray(item.key, submenu_hide_filters) == -1) {
				allowedSelectedFilters[i] = item
			}
		});

		//Hide global admin site filter for specific surveys and revert the filter to national filter
		//Configuration should be like this
		// 'hide_admin_site_filter' => array(
		// 		'survey_1' => true
		// 	),
		//under specific page configurations in application.config.inc.php file
		if(typeof(pageDetails['hide_admin_site_filter']) != 'undefined')
		{
			if(typeof(pageDetails['hide_admin_site_filter'][$scope.appState['submenu_key']]) != 'undefined')
			{
				var keepGoing = true;
				angular.forEach($scope.filters['admin_site']['value'], function(value, key){
					if(typeof(value['value']) != 'undefined')
					{
						angular.forEach(value['value'], function(in_val, in_key) {
							if(typeof(in_val['id']) != 'undefined' && keepGoing === true)
							{
								delete leftMenuFilters['admin_site'];
								keepGoing = false;
							}
						});
					}
				});

			}
		}

		if(ignoreSelectedFilters.length > 0)
		{
			var allowedSelectedFiltersClone = allowedSelectedFilters;
			$.each(ignoreSelectedFilters, function(key, value)
			{
				$.each(allowedSelectedFiltersClone, function(selected_key, selected_value)
				{
					if(value == selected_value.key)
					{
						delete allowedSelectedFilters[selected_key];
					}
				});
			});
		}
		selectedFilters = allowedSelectedFilters;

		//remove the hidden filters from the left menu
		var allowedLeftMenuFilters = {};
		$.each(leftMenuFilters, function(i, item){
			//If not in the array
			if($.inArray(i, hide_filters) == -1 && $.inArray(i, submenu_hide_filters) == -1) {
				allowedLeftMenuFilters[i] = item
			}
		});
		leftMenuFilters = allowedLeftMenuFilters;

		$scope.breadCrumb.pageText 		= typeof(pageDetails.label) != 'undefined'?pageDetails.label:pageText;
		$scope.breadCrumb.submenuText 	= submenuText;
		$scope.breadCrumb.filters  		= typeof(pageDetails.hide_breadcrumb_filters) != 'undefined' && pageDetails.hide_breadcrumb_filters == true ? {} : selectedFilters;
		$scope.leftMenuFilters  		= typeof(pageDetails.hide_breadcrumb_filters) != 'undefined' && pageDetails.hide_breadcrumb_filters == true ? {} : leftMenuFilters;
		
		//update experience dropdown
		$scope.experiences = [];
		$scope.selectedExperience = '';
		if(currentPageDetails !== null)
		{
			if(typeof(currentPageDetails.is_submenu) != 'undefined' && currentPageDetails.is_submenu == true 
					&& typeof(currentPageDetails.submenu) != 'undefined' && currentPageDetails.submenu.length > 0)
			{	
				
				//find experiences available and selected experience
				$.each(currentPageDetails.submenu, function(key, submenu)
				{
					//find selected experience if not already found
					if($scope.selectedExperience == '' && typeof (submenu.params) != 'undefined' && typeof (submenu.params.selectedKey) != 'undefined')
					{
						var submenuKey = submenu.params.selectedKey;
						if(typeof($location.$$search[submenuKey]) != 'undefined' && $location.$$search[submenuKey] == submenu.params[submenuKey])
						{
							$scope.selectedExperience = submenu.label;
						}
					}
					
					//add to options available
					$scope.experiences.push(submenu);
					
				});
			}
		}
		
		//store time period selected in a variable for display
		$scope.selectedTimePriod = ''
		$.each($scope.breadCrumb.filters, function(key, value)
		{
			if(typeof(value.key) != 'undefined' && value.key == 'submit_time')
			{
				$scope.selectedTimePriod = (typeof(value.label) != 'undefined') ? value.label : '';
				return false;
			}	
		});	
		
	}

	$scope.applyCustomFilter = function(filterKey, filterValue)
	{
		$scope.appState[filterKey] = filterValue;
		
		if(typeof($scope.filters[filterKey]['remove_selected_filter']) != 'undefined')
		{
			$.each($scope.filters[filterKey]['remove_selected_filter'], function(key, removeFilterItem)
			{
				if(typeof($scope.appState[removeFilterItem]) != 'undefined')
				{
					$scope.appState[removeFilterItem + '_value'] = '';
					$scope.appState[removeFilterItem + '_superset_value'] = '';
				}	
			});
		}
	}
	
	//method to broadcast filter event which is captured in leftController
	$scope.showFilter = function(filterKey, template)
	{
		var args = {'filterKey' : filterKey, 'template' : template};
		$scope.$broadcast('showFilterEvent', args);
	}
	
	//method to broadcast change experience event 
	$scope.changeExperience = function(params)
	{
		$scope.$broadcast('changePageEvent', params);
	}

    //check the current selected submenu : also exist in the Left side controller
    $scope.isSubmenuSelected = function(params)
    {
        if($stateParams.page == params.page)
        {
            if(typeof($stateParams[params.selectedKey]) != 'undefined' && $stateParams[params.selectedKey] == params[params.selectedKey])
            {
                return true;
            }
        }

        return false;
    }

	$scope.goToPage = function(page_href, params, submenu_key)
	{
		//Get page from navigation
		var page_found = null;
		$.each($scope.navigation, function(page_key, page)
		{
			if(page.href == page_href)
			{
				page_found = angular.copy(page);
			}
		});

		if(page_found)
		{
			var new_params = {};
			if(typeof submenu_key != 'undefined'){
				// console.log(page_found);
				var submenu_list = typeof page_found['submenu'] != 'undefined'?page_found['submenu']:{};
				
				var submenu_found = null;
				$.each(submenu_list, function(s_key, submenu)
				{
					if (submenu_key instanceof Array)
                    {
                        // check each multiple submenu_keys given
                        for (i = 0; i < submenu_key.length; i++) { 
                            if(submenu.key == submenu_key[i])
                            {
                                submenu_found = submenu;
                                return false;
                            }
                        }
                    }
                    else
                    {
                        // only one submenu_key given
                        if(submenu.key == submenu_key)
                        {
                            submenu_found = submenu;
                            return false;
                        }
                    }
				});
				var default_params = typeof submenu_found.params != 'undefined' ? submenu_found.params : {};
				var default_params_copy = angular.copy(default_params);

				new_params = $.extend( true, default_params_copy, params );
			}
			else if(typeof params != 'undefined'){
				//Override the default params with any new param value
				new_params = $.extend( true, page_found.params, params );
			}

			$scope.$broadcast('changePageEvent', new_params);
		}
		return null;
	}

	$scope.dynamicFiltersInPage = function(page, submenu_key)
	{
		var filters = [];
		if(typeof($scope.page_filters[page]) != 'undefined')
		{
			var all_page_filters = angular.copy($scope.page_filters[page]);
			if(submenu_key != '')
			{
				if(typeof(all_page_filters[submenu_key]) != 'undefined')
				{
					filters = all_page_filters[submenu_key];
				}	
			}
			else
			{
				filters = all_page_filters;
			}	
		}
		
		var dynamic_filters = {};
		$.each(filters, function(key, value)
		{
			if(typeof(value.is_dynamic_with_app_filter) != 'undefined' && value.is_dynamic_with_app_filter == true)
			{
				dynamic_filters[key] = value;
			}	
		});
		
		return dynamic_filters;
	}
	
	$scope.validateChangeInState = function(newState)
	{
		var changeInState = {};
		
		var deferred = $q.defer();
		
		//check for any dynamic filters in the page, if there are dynamic page filters, get the selected_value based on new state
		if(typeof(newState.page_filters) != 'undefined' && typeof(newState.page) != 'undefined')
		{
			var newSurveyKey = (typeof(newState.submenu_key) != 'undefined') ? newState.submenu_key : '';
			var dynamic_filters = $scope.dynamicFiltersInPage(newState.page, newSurveyKey);
			
			if(!jQuery.isEmptyObject(dynamic_filters))
			{
				//get available options and selected_value for new state
				dataService.getData('common/init_page', {'app_state' : newState} , 'POST')
					.then(function(response) {
						if(typeof(response.data) != 'undefined')
						{
							var new_page_filters = typeof(response.data) != 'undefined' && typeof(response.data.filters) != 'undefined' ? response.data.filters : null;
							
							$.each(dynamic_filters, function(key, value)
							{
								if(typeof(new_page_filters[key]) == 'undefined') 
								{
									if(typeof(newState.page_filters[key]) != 'undefined')
									{
										delete newState.page_filters[key];
										deferred.resolve(newState);
										delete $scope.appState.page_filters[key]
									}
								} else {
									//checking if newState page filter has filter key, if not add it
									if(typeof(newState.page_filters[key]) == 'undefined')
									{
										newState.page_filters[key] = '';
										deferred.resolve(newState);
										$scope.appState.page_filters[key] = '';
									}
								}
								//check if the filter selection being made matches with response(the one suggested from backend based on the newState)
								var newStateFilterSelection = typeof(newState.page_filters[key] != 'undefined') ? newState.page_filters[key] : null;
								if(newStateFilterSelection != null && typeof(new_page_filters[key]) != 'undefined' && typeof(new_page_filters[key].selected_value) != 'undefined' && newStateFilterSelection != new_page_filters[key].selected_value)
								{
									if(typeof(changeInState.page_filters) == 'undefined')
									{
										changeInState.page_filters = {};
									}	
									changeInState.page_filters[key] = new_page_filters[key].selected_value;	
								}	
							});
							
							deferred.resolve(changeInState);
						}
					}
				);
			}
			else
			{
				deferred.resolve(changeInState);
			}	
		}
		
		return deferred.promise;
	}
	
	$scope.cancelAllRequests = function() {
		httpPendingRequests.cancelAll();
	}

	$scope.isPageLoaded = function()
	{
		var pending_items = $(httpPendingRequests.get()).toArray().length;
		if(pending_items == 0)
		{
			return true;
		}
		return false;
	}
	
	//function to handle export click from header
	$scope.exportPage = function(exportItem, exportKey) {
		//broadcast the event to the child controller and then caught by the respective page controller
		var exportObject = {'key' : exportKey, 'item' : exportItem}
		$scope.$broadcast('exportPageEvent', exportObject);
	}
	
	$scope.startExport = function(params, pageScope, currentPageConfig)
	{
		//cancel current exports
		$scope.cancelExport();
		$scope.exportInProgress = false;

		var export_unique_key = createGuid();
		var export_page = typeof(pageScope.appState.page) != 'undefined' ? pageScope.appState.page : '';

		var pageState = pageScope.appState;
		/*if(typeof(pageState.page_filters) != 'undefined')
		{
			$.each(pageState.page_filters, function(filter_key, filter_value){
				if(typeof(pageScope[filter_key]) != 'undefined')
				{
					if(typeof(pageScope[filter_key].not_accessible) != 'undefined' && pageScope[filter_key].not_accessible == true)
					{
						delete pageState.page_filters[filter_key];
					}
				}
			})
		}*/

		var postData = {};
		postData.app_state = pageState;
		postData.filters = currentPageConfig.filters;
		postData.export_components = {};
		postData.export_params = params;
		postData.export_id = export_unique_key;
		postData.breadcrumb = $scope.breadCrumb;

		if(params.item.export_type == 'pdf')
		{
			if(typeof(params.item.html_post) != undefined && params.item.html_post === true)
			{
				postData.pdf_content = $('#main-content-wrap').html();
			}
		}

		if(typeof($scope.google_analytics_tracking_code) != 'undefined' && $scope.google_analytics_tracking_code != '')
		{
			var submenu_label = $scope.appState.submenu_key;
			if(typeof($scope.submenu_labels) != 'undefined' && typeof($scope.submenu_labels[$scope.appState.submenu_key]) != 'undefined')
			{
				submenu_label = $scope.submenu_labels[$scope.appState.submenu_key].toLowerCase();
			}

			gtag('event', pageState.page+'_'+submenu_label+'_export', {'event_category': pageState.page+'_export', 'event_label': 'Export_'+params.item.export_type});
		}
		
		$.each(currentPageConfig.components, function(componentKey, component)
		{
			//check if is not accessible, then skip
			if(typeof(component.not_accessible) != 'undefined' && component.not_accessible == true)
			{
				return true;
			}
			
			if(typeof(pageScope[componentKey]) != 'undefined')
			{
				postData.export_components[componentKey] = {};
				
				//add page number for dbtable component
				if(component.component_type == 'dbtable')
				{
					//validate the instance of data table
					if(typeof pageScope[componentKey].instance.DataTable == 'undefined')
					{
						return true;
					}
					page_info = pageScope[componentKey].instance.DataTable.page.info();
					postData.export_components[componentKey].currentPage = page_info.page;
				}	
				
				//copy everything except instance
				$.each(pageScope[componentKey], function(key, value)
				{
					if(key != 'instance' && key != 'selectedRow' && key != 'selectedRowIndex')
					{
						postData.export_components[componentKey][key] = angular.copy(value);
					}	
				});
				if(pageScope['transcript'] == 1)
				{
					//Handle Survey Transcript here
					postData.export_components[componentKey].transcript = true;
				}
			}	
		});
		
		//validate export and then start export
		dataService.getData('export/validate_export', postData, 'POST', true, 'exports', true)
			.then(function(response) {
				if(typeof(response.data) != 'undefined' && response.data == 'success')
				{
					$scope.exportInProgress = true;
					
					//change UI to show progress
					$('#export_dropdown').addClass('in-progress');
					$('#export_progress_container').show();
					
					//get export
					var export_url = typeof(params.item.export_url) != 'undefined' ? params.item.export_url : 'export';
					dataService.getData(export_url, postData, 'POST', true, 'exports', true)
						.then(function(response) {
							if(response === false)//validation error, popup will be shown automatically from dataService
							{
								$scope.cancelExport();
							}
							else
							{	
								//if there is a response and if if its not a successful json response, it will be an error
								if(response)
								{
									if(typeof(response.data) == 'undefined' || typeof(response.data.export_success) == 'undefined' || response.data.export_success != true)
									{
										var message = typeof(response.message) != 'undefined' && response.message != '' ? response.message : '';
										$scope.cancelExport();
										$scope.showExportError(response, params, export_page, message);
									}	
								}	
							}
							//do nothing, this will be taken care of by the 'getExportStatus' method
					});
					
					//start polling for export progress
					$scope.getExportStatus(export_unique_key, params, export_page);
				}	
		});
	}
	
	$scope.getExportStatus = function(export_unique_key, params, export_page)
	{
		var statusParams = {};
		statusParams.export_id = export_unique_key;
		if($scope.exportInProgress === true) {
			dataService.getData('export/status', statusParams, 'POST', true, 'exports', true)
				.then(function(response) {
					if(typeof(response.data) != 'undefined')
					{
						//check for any errors during the process
						if(typeof(response.data.error_code) != 'undefined')
						{
							var message = typeof(response.message) != 'undefined' && response.message != '' ? response.message : '';
							$scope.cancelExport();
							$scope.showExportError(response, params, export_page, message);
						}
						else if(typeof(response.data.progress) != 'undefined')
						{	
							$('#export_progress_container .progress-bar').css('width', response.data.progress + '%');
							$('#export_progress_container .export-percent').html(response.data.progress + '%');
							if(response.data.progress >= 100)
							{
								$scope.finishExport();
								$scope.showExportComplete(response.data.file_location, params, export_page);
							}
							else
							{
								setTimeout(function() {$scope.getExportStatus(export_unique_key, params, export_page)}, 3000);
							}
						}
					}	
			});
		}
		
	}
	
	$scope.finishExport = function()
	{
		//reset all 
		$('#export_progress_container .progress-bar').css('width', '5%');
		$('#export_progress_container .export-percent').html('5%');
		$('#export_dropdown').removeClass('in-progress');
		$('#export_progress_container').hide();
		
		$scope.exportInProgress = false;
	}
	
	$scope.cancelExport = function()
	{
		//cancel current exports
		httpPendingRequests.cancelType('exports');
		$scope.finishExport();
		
		$scope.exportInProgress = false;
	}
	
	$scope.showExportComplete = function(file_location, params, export_page)
	{
		var export_icon = typeof(params.item) != 'undefined' && typeof(params.item.icon) != 'undefined' ? 'fa ' + params.item.icon : 'fa';
		var export_icon_color = typeof(params.item) != 'undefined' && typeof(params.item.color) != 'undefined' ? ' style="color:' + params.item.color + '"' : '';
		var export_target = typeof(params.item) != 'undefined' && typeof(params.item.target) != 'undefined' ? params.item.target : 'action_frame';
		export_page = (typeof($scope.navigation[export_page]) != 'undefined' && typeof($scope.navigation[export_page].label) != 'undefined') ? $scope.navigation[export_page].label.toLowerCase() : export_page;
		var export_page_text = typeof(export_page) != 'undefined' && export_page != '' ? ' '+ export_page + ' page' : '';
		var export_link = file_location.replace('exports/', 'download.php?file=');
		var absUrl = $location.absUrl();
		var replace_val = 'www.';
		if(absUrl.indexOf('/www.') === -1)
		{
			replace_val = '';
		}
		export_link = export_link.replace('www1.', replace_val);
		export_link = export_link.replace('www2.', replace_val);
		export_link = export_link.replace('staging1.', 'staging.');
		export_link = export_link.replace('staging2.', 'staging.');
		
		var notify_html	= '<div class="modal-dialog export-download">'+
							'<div class="modal-content">';
			notify_html		+= '<div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><b><i ' + export_icon_color + ' class="' + export_icon + '"></i>&nbsp;Your' + export_page_text + ' export is ready.</b></div>';
			notify_html 		+= '<div class="modal-body export-download-body">';
			notify_html 		+= '<div><p><a class="download-link" href="' + export_link + '" target="'+export_target+'"><i class="fa fa-download"></i>&nbsp;Click here to download</a></p></div></div>';
			notify_html 		+= '<div class="modal-footer"><button type="button" class="btn btn-default btn-theme-default" data-dismiss="modal">Close</button></div>';
			notify_html		+= '</div></div>';

			$('#popNotify').modal('hide');// if you don't want to lose the reference to previous backdrop
			$('#popNotify').data('bs.modal',null); // this clears the BS modal data

			$('#popNotify').html(notify_html);
			$('#popNotify').modal({
			    backdrop: 'static',
			    keyboard: true, 
			    show: true
			});
	}
	
	$scope.showExportError = function(response, params, export_page, message)
	{
		var export_icon = typeof(params.item) != 'undefined' && typeof(params.item.icon) != 'undefined' ? 'fa ' + params.item.icon : 'fa';
		var export_icon_color = typeof(params.item) != 'undefined' && typeof(params.item.color) != 'undefined' ? ' style="color:' + params.item.color + '"' : '';
		var export_page_text = typeof(export_page) != 'undefined' && export_page != '' ? ' '+ export_page + ' page' : '';
		var export_error_message = typeof(message) != 'undefined' && message != '' ? message : 'Sorry, an error occured while generating the ' + export_page_text + ' export. Please try again later.';
		
		var notify_html	= '<div class="modal-dialog export-download">'+
							'<div class="modal-content">';
			notify_html		+= '<div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><b><i ' + export_icon_color + ' class="' + export_icon + '"></i>&nbsp;Export Failed!</b></div>';
			notify_html 		+= '<div class="modal-body export-download-body">';
			notify_html 		+= '<div><p>' + export_error_message + '</p></div></div>';
			notify_html 		+= '<div class="modal-footer"><button type="button" class="btn btn-default btn-theme-default" data-dismiss="modal">Close</button></div>';
			notify_html		+= '</div></div>';

			$('#popNotify').modal('hide');// if you don't want to lose the reference to previous backdrop
			$('#popNotify').data('bs.modal',null); // this clears the BS modal data
			
			$('#popNotify').html(notify_html);
			$('#popNotify').modal({
			    backdrop: 'static',
			    keyboard: true, 
			    show: true
			});
	}
	
	//To fire window resize event to perform any adjustments to the components when a tab is selected
	$scope.tabSelected = function(tabName) {
			//resize on tab change
			$( window ).resize();
			setTimeout(function(){
				$( window ).resize();
			}, 200);
	}
	//----FUNCTION DECLARATION END------//
	
	//flag to detect export progress
	$scope.exportInProgress = false;

	//application state(=URL params), used in every page request
	$scope.appState = $rootScope.appState;

	//variables in main scope, updated later in child controllers
	$scope.header 		= $rootScope.header;
	$scope.navigation 	= $rootScope.navigation;
	$scope.filters 		= $rootScope.filters;
	$scope.page_filters	= $rootScope.page_filters;
	$scope.page_params	= $rootScope.page_params;
	$scope.breadCrumb 	= {'pageText' : '', 'submenuText' : '', 'filters' : []};

	if(typeof($location.search().submenu_key) != 'undefined')
	{
		var params_value_obj = $location.search();
		var param_submenu = $location.search().submenu_key;
		var param_filter_transcript = 'filter_transcript_'+param_submenu;

		var transcript_survey_id = false;
		angular.forEach(params_value_obj, function(value, key) {
			if(key == param_filter_transcript)
			{
				transcript_survey_id = value;
			}
		});

		if(transcript_survey_id != false)
		{
			$scope.transcript_survey_id = transcript_survey_id;
			transcriptParams = {};
			transcriptParams.survey_id = transcript_survey_id;
			transcriptParams.survey_key = param_submenu;
			$http({url: 'common/get_correct_survey_key_based_on_login', data:transcriptParams, method : 'POST' , async : false, headers : {"X-Requested-With" : "XMLHttpRequest"}}).then(function (response)
			{
				var crct_survey_key = response.data.data;
				if(crct_survey_key != '')
				{
					var url = $location.absUrl().split('#')[0];
					url += '#/surveys?submenu_key='+crct_survey_key+'&filter_transcript_'+crct_survey_key+'='+transcript_survey_id;
					$window.location.href = url;
				}
			});
		}
	}
	
	//store staus flag of event listener for app_scope_page_filters
	$scope.app_scope_page_filters_listener = false;
	
	//if requesting for a particular page, direct to that page. If not redirect to default page with default params
	if(typeof($location.$$path) != 'undefined' && ($location.$$path) != '')
	{
		var page_in_url = $location.$$path.replace('/', '');
		if(typeof($scope.navigation[page_in_url]) != 'undefined')
		{	
			$scope.appState.page = page_in_url;
		}
	}

	if($rootScope.notification_email_tracking_pages && jQuery.inArray(page_in_url, $rootScope.notification_email_tracking_pages) !== -1)
	{
		if($location.$$url.indexOf('?uid=') !== -1 || $location.$$url.indexOf('&uid=') !== -1)
		{
			var lib__urls = $location.$$url;
			var lib__myurls = $location.$$url.indexOf('?uid=') !== -1 ? lib__urls.split("?uid=") : lib__urls.split("&uid=");
			var lib__mylasturls = lib__myurls[1];
			var lib__mynexturls = lib__mylasturls.split("&");
			var lib__url = lib__mynexturls[0];

			var trackParams = {};
			trackParams.uid = lib__url;
			dataService.getData('library/track_notification_email_click', trackParams, 'POST')
			.then(function(response) {
				if(typeof(response.data) != 'undefined')
				{
					
				}
				
			});
		}
	}
		
	
	//get default app params, page params and page filters
	var defaultSubmenuKey = typeof($scope.appState.submenu_key) != 'undefined' ? $scope.appState.submenu_key : '';
	var pageParamsFilters = appService.getPageParamsFilters($scope.appState.page, $scope, $location.$$search, defaultSubmenuKey);

	//replace values with default values
	$.each(pageParamsFilters, function(key, value)
	{
		$.each(value, function(filterKey, filterValue)
		{
			if(typeof($scope.appState[filterKey]) != 'undefined')
			{
				pageParamsFilters[key][filterKey] = angular.copy($scope.appState[filterKey]);
			}
		});
	});
	
	//add page params and filters to state, replace values with values from URL, skip extra params in URL
	$scope.appState = appService.addParamsFiltersToState(pageParamsFilters, $location.$$search, $scope);
	
	//Initial page load: register location change as initiated by appState so that locationChange event will not be called on pageload  
	$scope.locationChangeInitiator = 'appState';
	
	//add current state(default params) to the URL
	$scope.changeToNewState();
	
	//reset all values in $rootScope except appState once those are passed to the $scope
	$rootScope.header 		= {};
	$rootScope.navigation 	= {};
	$rootScope.filters 		= {};
	$rootScope.page_filters	= {};
	$rootScope.page_params	= {};

	//copy appState to $rootScope to share on factory
	$rootScope.appState = $scope.appState;
	
	//set as newpage to show animation
	$rootScope.newPage = true;

	//watch appState and change URL for every change in state
	$scope.$watch('appState', function(newState, oldState) {
		if(newState !== oldState)
		{
			//set locationChangeInitiator as initiated by appState
			$scope.locationChangeInitiator = 'appState';
			
			//check if the appState was already validated
			if(typeof($scope.appStateValidated) == 'undefined' || $scope.appStateValidated == false)
			{	
				//validate new state
				$scope.validateChangeInState(newState).then(function(changeInState) 
				{
                                        //push the old state to the root scope
                                        $rootScope.previousState = oldState;

					//if there is a suggested change, apply the change in scope
					if(!jQuery.isEmptyObject(changeInState))
					{
						$.extend( true, $scope.appState, changeInState );
						
						//record the validation to avoid duplicate validation 
						$scope.appStateValidated = true;

						$timeout(function() {
							$scope.$apply();
				        }, 10);
						
						//return now, the appState change will call this function again
						return false;
					}
					else
					{
						$scope.InitiateNewStateChange();
					}	
					
				});
			}
			else
			{	
				$scope.appStateValidated = false;
				$scope.InitiateNewStateChange();
			}
		}
	}, true);
	
	//watch location change and make appState in sync with location
	$scope.$on("$locationChangeStart", function handleLocationChangeStartEvent( event ) {
			if(typeof($scope.locationChangeInitiator) != 'undefined' && $scope.locationChangeInitiator != '')
			{
				//reset locationChangeInitiator flag
				$scope.locationChangeInitiator = '';
				return true;
			}
			else //location changed by browser back button or changing URL
			{	
				var next_page = $location.$$path.replace('/', '');
				
				//get default app params, page params and page filters
				var pageParamsFilters = appService.getPageParamsFilters(next_page, $scope, $location.$$search);
				
				//replace values with current state values, do not copy page filters
				$.each(pageParamsFilters, function(key, value)
				{
					$.each(value, function(filterKey, filterValue)
					{
						if(typeof($scope.appState[filterKey]) != 'undefined' && filterKey != 'page_filters')
						{
							pageParamsFilters[key][filterKey] = angular.copy($scope.appState[filterKey]);
						}
					});
				});
				
				//add page params and filters to state, replace values with values from URL, skip extra params in URL
				var next_state = appService.addParamsFiltersToState(pageParamsFilters, $location.$$search, $scope);
				
				var current_state = angular.copy($scope.appState);
				
				//check if there is a change from current state
				if(angular.equals(next_state, current_state))
				{
					event.preventDefault();
				}
				else //detected a change
				{
					$scope.appState = next_state;
					
					//copy the state to rootScope to fetch pageConfig
					$rootScope.appState = $scope.appState;
					
					//register location change as initiated by browser 
					$scope.locationChangeInitiator = 'browser';
					
					//prevent event propogation to handle this via appState change event as usual
					event.preventDefault();
					
					//apply appState change to trigger appState change event
					$timeout(function() {
						$scope.$apply();
			        }, 10);
				}	
			}
        }
    );
	
	//update breadcrumb
	$scope.updateBreadCrumbs();
	
});


app.controller('headerController', function($http, $scope, $rootScope, $stateParams, $location, dataService, appService, $modal) {
	$scope.goToNotificationPage = function(page_href)
	{
		var page_found = null;
		$.each($scope.navigation, function(page_key, page)
		{
			if(page.href == page_href)
			{
				page_found = page;
			}
		});

		if(page_found)
		{
			$rootScope.$broadcast('changePageEvent', page_found.params);
		}
		return null;
	}

	$scope.changePageFromHeader = function(params)
	{
		$rootScope.$broadcast('changePageEvent', params);
	}
    
});

app.controller('leftSideController', function($http, $scope, $rootScope, $stateParams, $state, $location, dataService, $modal, appService) {
	
	//capture experience change triggered from dropdown (id=experience_dropdown)
	$scope.$on('changePageEvent', function(event, args) {
		$scope.changePage(args);
	});

	$scope.checkVisibility = function(pageConfig)
	{
		var visibility = false;
		$.each(pageConfig, function(pageKey, pageValue)
		{
			if(pageKey == 'hide_on_selected_filter_value')
			{
				$.each(pageValue, function(pageSubKey, pageSubValue)
				{
					if(pageSubKey == 'submit_time')
					{
						if(pageSubValue.indexOf($scope['appState']['submit_time']) != -1) 
						{
							visibility = true;
						}
					}

					if(pageSubKey == 'admin_site')
					{
						$.each(pageSubValue, function(pageSuperSubKey, pageSuperSubValue){
							if(typeof($scope.appState[pageSuperSubKey]) != 'undefined') 
							{
								if(pageSuperSubValue['operator'] == 'not_equal')
								{
									if($scope.appState[pageSuperSubKey] != pageSuperSubValue['value'])
									{
										visibility = true;
									}
								}

								if(pageSuperSubValue['operator'] == 'equal')
								{
									if($scope.appState[pageSuperSubKey] == pageSuperSubValue['value'])
									{
										visibility = true;
									}
								}
							}
						});
					}

					if(visibility === true)
					{
						return false;
					}

				});
			}
			
		});
		//console.log(visibility);
		return visibility;
	}
	
	$scope.changePage = function(params, new_page_flag)
	{
		//if there is submenu, page will be null and return false (click from 'Home', NOT 'Home -> Sales')
		if(typeof(params.page) == 'undefined' || params.page === null)
		{
			return false;
		}


		if(typeof(params.submenu_url) != 'undefined' && params.submenu_url != '')
		{
			window.open(params.submenu_url, '_blank'); // in new tab
			//$window.location.href = params.submenu_url;
			return false;
		}


		//take a copy of the page params so that it doesnt update the original params
		var new_params = angular.copy(params);
		if(new_page_flag == true)
		{
			//page change
			var target_page  = new_params.page;
			//update survey_key
			var temp_submenu_key = angular.copy($scope.$parent.appState['submenu_key']);
			var all_pages = angular.copy($scope.$parent.page_params);
			//check if the submenu key is available for the page
			if(typeof all_pages[target_page] != 'undefined' && typeof all_pages[target_page][temp_submenu_key] != 'undefined')
			{
				new_params['submenu_key'] = temp_submenu_key;
			}
		}

		//Modify the submit time filter with the latest data available for the page
		if(typeof($scope.navigation[params.page]) != 'undefined' && typeof($scope.navigation[params.page]['hide_on_time_periods']) != 'undefined')
		{
			if(typeof($scope.navigation[params.page]['hide_on_time_periods'][params.submenu_key]) != 'undefined')
			{
				var all_time_periods = $scope.filters['submit_time']['value'];
				var hide_on_time_periods = $scope.navigation[params.page]['hide_on_time_periods'][params.submenu_key];
				var time_periods_key = Object.keys(all_time_periods);
				var time_period_diff = $(time_periods_key).not(hide_on_time_periods).get();
				var current_time_period = angular.copy($scope.appState.submit_time);
				if (jQuery.inArray(current_time_period, time_period_diff) === -1 && time_period_diff.length > 0)
				{
					var default_time_period_for_page = time_period_diff[0];
					var default_time_period_array = all_time_periods[default_time_period_for_page];
					var default_time_period_result_array = [];
					var time_period_position = 0;
					var time_period_found = false;

					angular.forEach(default_time_period_array, function(value, key){
						angular.forEach(value, function(sub_value, sub_key){
							if(sub_value['position'] == time_period_position)
							{
								time_period_found = true;
								default_time_period_result_array = sub_value;
								return false;
							}
						});
						if(time_period_found === true)
						{
							return false;
						}
					});

					if(Object.keys(default_time_period_result_array).length > 0)
					{
						$scope.appState['submit_time'] = default_time_period_for_page;
						$scope.appState['submit_time_value'] = default_time_period_result_array['id'];
					}
				}
			}
		}

		if(typeof($scope.navigation[params.page]) != 'undefined' && typeof($scope.navigation[params.page]['hide_admin_site_filter']) != 'undefined') {
			if (typeof ($scope.navigation[params.page]['hide_admin_site_filter'][params.submenu_key]) != 'undefined' && $scope.navigation[params.page]['hide_admin_site_filter'][params.submenu_key] == true) {
				var keepGoing = true;
				angular.forEach($scope.filters['admin_site']['value'], function(value, key){
					if(typeof(value['value']) != 'undefined')
					{
						angular.forEach(value['value'], function(in_val, in_key) {
							if(typeof(in_val['id']) != 'undefined' && keepGoing === true)
							{
								$scope.appState['admin_site'] = key;
								$scope.appState['admin_site_value'] = in_val['id'];
								$scope.appState['admin_site_superset_value'] = '';
								keepGoing = false;
							}
						});
					}
				});
			}
		}

		//Modify the submit time filter with the default time period change for the page
		if(typeof($scope.navigation[params.page]) != 'undefined' && typeof($scope.navigation[params.page]['defualt_time_preiod']) != 'undefined')
		{
			if(typeof($scope.navigation[params.page]['defualt_time_preiod'][params.submenu_key]) != 'undefined')
			{
				var all_time_periods_for_new_request = $scope.filters['submit_time']['value'];
				var new_time_period_request = $scope.navigation[params.page]['defualt_time_preiod'][params.submenu_key];

				if (jQuery.inArray(new_time_period_request, all_time_periods_for_new_request))
				{
					var new_time_period_array = all_time_periods_for_new_request[new_time_period_request];
					var new_default_time_period_result_array = [];
					var new_time_period_position = 0;
					var new_time_period_found = false;

					angular.forEach(new_time_period_array, function(value, key){
						angular.forEach(value, function(sub_value, sub_key){
							if(sub_value['position'] == new_time_period_position)
							{
								new_time_period_found = true;
								new_default_time_period_result_array = sub_value;
								return false;
							}
						});
						if(new_time_period_found === true)
						{
							return false;
						}
					});

					if(Object.keys(new_default_time_period_result_array).length > 0)
					{
						$scope.appState['submit_time'] = new_time_period_request;
						$scope.appState['submit_time_value'] = new_default_time_period_result_array['id'];
						//next time onwards the time filter change should work with out switching the time period. For that deleting the defualt_time_period survey_key
						delete $scope.navigation[params.page]['defualt_time_preiod'][params.submenu_key];
					}
				}
			}
		}
		
		//---------------- start: check for any survey restrictions ----------------------------------------------------------
        //This is to check if a page survey do not have entry for the selected time filter.
        //We will pick the last available time period for that survey
        //Get all selected time filter values
        var all_time_periods = angular.copy($scope.filters['submit_time']['value']);
        var current_submit_time = angular.copy($scope.appState.submit_time);
        var current_submit_time_value = angular.copy($scope.appState.submit_time_value);//$scope.appState['submit_time_value'];
        var temp_submenu_key = angular.copy(new_params['submenu_key']);

        if(typeof  all_time_periods[current_submit_time] != 'undefined'
            && typeof  all_time_periods[current_submit_time]['value'] != 'undefined'
            && typeof  all_time_periods[current_submit_time]['value'][current_submit_time_value] != 'undefined'
        ){
            var current_time_filter_item = all_time_periods[current_submit_time]['value'][current_submit_time_value];

            //check if the selected filter is restricted for the survey
            if(typeof  current_time_filter_item.surveys_restricted != 'undefined' &&
                jQuery.inArray(temp_submenu_key, current_time_filter_item.surveys_restricted) !== -1
            )
            {
                //reset the filter
                //choose the first available one from the list
                var default_time_period_array = all_time_periods[current_submit_time]['value'];
                var default_time_period_result_array = [];

                angular.forEach(default_time_period_array, function(value, key){
                    if(
                        (typeof value['surveys_restricted'] != 'undefined' &&
                        jQuery.inArray(temp_submenu_key, value['surveys_restricted']) === -1) ||
                        typeof value['surveys_restricted'] == 'undefined'
                    )
                    {
                        default_time_period_result_array.push(value);
                    }
                });

                //sort by position
                default_time_period_result_array.sort(function(a, b){
                    return a.position > b.position;
                });

                var new_item = default_time_period_result_array[0];
                if(Object.keys(new_item).length > 0)
                {
                    $scope.appState['submit_time_value'] = new_item['id'];
                }
            }
        }
        //---------------- end: check for any survey restrictions ----------------------------------------------------------

		//get default app params, page params and page filters
		var pageParamsFilters = appService.getPageParamsFilters(new_params.page, $scope.$parent, new_params);
		
		//replace values with current state values, do not copy page filters
		$.each(pageParamsFilters, function(key, value)
		{
			$.each(value, function(filterKey, filterValue)
			{
				if(typeof($scope.$parent.appState[filterKey]) != 'undefined' && filterKey != 'page_filters')
				{
					pageParamsFilters[key][filterKey] = angular.copy($scope.$parent.appState[filterKey]);

					//Reset admin site filter to the default on each experiance change if defined in the application config
					if($rootScope.reset_admin_site_filters_on_experiance_change)
					{
						if(filterKey == 'admin_site'||filterKey == 'admin_site_value'||filterKey == 'admin_site_superset_value')
						{
							var param_submenu_key = angular.copy(new_params['submenu_key']);
							if(
								typeof $rootScope.reset_admin_site_filters_on_experiance_change[param_submenu_key] != 'undefined' 
								&& typeof ($rootScope.reset_admin_site_filters_on_experiance_change[param_submenu_key][filterKey]) != 'undefined'
							)
							{
								pageParamsFilters[key][filterKey] = angular.copy($scope.reset_admin_site_filters_on_experiance_change[param_submenu_key][filterKey]);
							}

							//Reset superset selection for experiance
							if(new_page_flag != true && filterKey == 'admin_site_superset_value')
							{
								//Check if there are multiple admin sites available, if so reset the site selection
								var all_filters = angular.copy($scope.$parent.filters);
								var site_filters = typeof all_filters['admin_site'] != 'undefined'?all_filters['admin_site']:[];
								var site_filter_superset = typeof site_filters['value'] != 'undefined' && typeof site_filters['value']['superset'] != 'undefined'?site_filters['value']['superset']:[];
								var sites_available = typeof site_filter_superset['value'] != 'undefined'? site_filter_superset['value'] :[];

								if(sites_available.length != 1)
								{
									pageParamsFilters[key][filterKey] = '';
								}
							}
						}
					}
				}

			});
		});
		
		//add page params and filters to state, replace values with values from page params
		$scope.$parent.appState =  appService.addParamsFiltersToState(pageParamsFilters, new_params, $scope);
		//page change
		$rootScope.newPage = true;

	}
	
	$scope.showFilter = function(filterKey, template)
	{
		$scope.filterPopupKey = filterKey;
		var modalInstance = $modal.open({
	           templateUrl: template,
	           controller: ModalInstanceCtrl,
	           scope : $scope,
	           windowClass : filterKey + '_window'
	    });
	}
	
	//to listen for events from Main controller (e.g. breadcrum click)
	$scope.$on('showFilterEvent', function(event, args) 
	{
		$scope.showFilter(args.filterKey, args.template);
	});

	//select the current Submenu
	$scope.isSubmenuSelected = function(params)
	{
		if($state.includes(params.page))
		{
			if(typeof($state.params[params.selectedKey]) != 'undefined' && $state.params[params.selectedKey] == params[params.selectedKey])
			{
				return true;
			}
		}
		
		return false;
	}

	//Check if Items are visible for the left menu filter
	$scope.checkFilterItemsVisibility = function (items) {
		var size = 0;
		$.each(items, function(key, value)
		{
			if (value.visibility != 'hidden') size++;
		});
		return size === 0;
	};
	
});

function ModalInstanceCtrl($scope, $modalInstance, $timeout, $location) {
	
	$scope.filter = angular.copy($scope.$parent.$parent.filters[$scope.filterPopupKey]);
	$scope.appState = $scope.$parent.$parent.appState;
	$scope.subset = {};
	$scope.hierarchy_subset = {}; //store hierarchy subset
	$scope.parallel_filter_items = {}; //store parallel filter items
	$scope.selected_parallel_filter = {}; //selected parallel filter
	$scope.hierarchy_generic_category_items = {}; //filter items for the first tab (Global)
	$scope.subsetTitle = {};
	$scope.currentState = angular.copy($scope.appState); //store current state for dirty checking
	$scope.activeTab = null;
	$scope.currentFilterId = null;
	$scope.query = {};
	
	//no show all filters
	$scope.noShowAllFilter = {};
	
	//select showAll
	$scope.selectShowAll = {};
	
	//display_inactive_dealers
	$scope.display_inactive_dealers = angular.copy($scope.$parent.$parent.display_inactive_dealers);

	$scope.selectedPageHasAccessFilter = function(filterItem)
	{
		var pageText =  angular.copy($location.$$path);
		pageText 	 = pageText.replace('/', '');
		var allow = true;
		var current_page = typeof($scope.appState['page']) != 'undefined' ? $scope.appState['page'] : null;
		if(current_page != null)
		{
			if(typeof($scope.navigation[current_page]) != 'undefined')
			{
				var current_page_config = $scope.navigation[current_page];
				if(typeof(current_page_config['hide_on_time_periods']) != 'undefined')
				{
					if(typeof(current_page_config['hide_on_time_periods'][$scope.appState['submenu_key']]) != 'undefined')
					{
						var time_periods_to_hide = current_page_config['hide_on_time_periods'][$scope.appState['submenu_key']];
						if(time_periods_to_hide.indexOf(filterItem['objectKey']) != -1)
						{
							//Allowed
							allow = false ;
						}
					}
				}
			}		
		}
		return allow;
	}

	$scope.selectedSubmenuHasAccessFilter = function(item)
	{
		var allow = true;
		var current_submenu_key = typeof($scope.appState['submenu_key']) != 'undefined' ? $scope.appState['submenu_key'] : null;
		if(current_submenu_key != null)
		{
		    if(typeof item.surveys_restricted != 'undefined' &&
                jQuery.inArray(current_submenu_key, item.surveys_restricted) !== -1
            )
		    {
                //Allowed
                allow = false;
            }
		}
		return allow;
	}
	
	//-------------------------START FUNCTIONS---------------------//
	$scope.adminSiteSearchFilter = function (item) 
	{ 
		var valid = true;
		// console.log($scope.query);

		//------------------------------ Start Sarch box processing -------------------------------------
	    if ( typeof $scope.query.label != 'undefined' && $scope.query.label != '' && !(item.label.toLowerCase().indexOf($scope.query.label.toLowerCase()) != -1)){
	        valid = false;
	    }
	    //if the item has children and the search matches the child's value
	    var children = typeof item.children != 'undefined'? item.children : {};
	    if(children)
	    {
	    	$.each(children, function(key, value)
			{
				var child_label = typeof value.label != 'undefined'? value.label : '';
				if(typeof $scope.query.label != 'undefined' && child_label.toLowerCase().indexOf($scope.query.label.toLowerCase()) != -1)
				{
					valid = true;
					return false;
				}
			});
	    }
	    //------------------------------ End Sarch box processing ---------------------------------------
	    if(typeof item.is_active_dealer == 'undefined' || item.is_active_dealer === '' || item.is_active_dealer === null)
	    {
	    	var active_from_date = typeof item.active_from_date != 'undefined'?item.active_from_date:'';
			var inactive_from_date = typeof item.inactive_from_date != 'undefined'?item.inactive_from_date:'';
			item.is_active_dealer = $scope.is_active_between_range(active_from_date, inactive_from_date, time_from, time_to);
	    }

	    //check for inactive dealers
	    if(!$scope.display_inactive_dealers)
	    {
	    	//hide dealers
	    	if(item.is_active_dealer == false)
	    	{
	    		valid = false;
	    	}
	    }

	    if(typeof item.hide != 'undefined' && item.hide == 1)
	    {
	    	valid = false;
	    }
	    return valid;
	};

	$scope.adminSiteChildSearch = function(item)
	{
		valid = false;
		//if the item has children and the search matches the child's value
	    var children = typeof item.children != 'undefined'? item.children : {};
	    if(children && typeof $scope.query.label != 'undefined' && $scope.query.label != '')
	    {
	    	$.each(children, function(key, value)
			{
				var child_label = typeof value.label != 'undefined'? value.label : '';
				if(child_label.toLowerCase().indexOf($scope.query.label.toLowerCase()) != -1)
				{
					valid = true;
					return false;
				}
			});
	    }

	    return valid;
	}
	
	$scope.isAdminSiteChildSelected = function(filterKey, item, filterType, filterValue)
	{
		valid = false;
		//if the item has children and the search matches the child's value
	    var children = typeof item.children != 'undefined'? item.children : {};

	    //check if any of the child items is currently selected
		if(children){
			$.each(children, function(key, value)
			{
				if($scope.isHierarchySupersetSelected(filterKey, value, filterType,filterValue))
				{
					valid = true;
					return false;
				}
			});
		}

	    return valid;
	}
	
	//filter the superset based on the category selected
	$scope.filterSuperset = function(filterKey, filterValue)
	{
		//show full set when filterValue is null
		$scope.subset[filterKey] = angular.copy($scope.filter.value.superset);
		
		if(filterValue != null)
		{	
			$timeout(function(){
				$scope.currentFilterId = filterValue;
			}, 10);
		}
				
		//if filterValue is found, filter items to that filter type
		if(typeof(filterValue) != 'undefined' && filterValue != null && filterValue != '')
		{	
			//store new values
			var subsetValues = [];
			
			var needleKey = filterKey + '_id';
			$.each($scope.filter.value.superset.value, function(key, value)
			{
				//if all dealers or dealer from this category
				if(value.id == '' || (typeof(value[needleKey]) != 'undefined' && value[needleKey] == filterValue))
				{
					subsetValues.push(value);
				}
			});
			
			//wait for digest cycle to fix ng-repeat delay issue
			$timeout(function(){
				$scope.subset[filterKey].value = subsetValues;
			}, 10);
		}
		else
		{
			//If filter value is null, get all items with a filter key defined
			//store new values
			var subsetValues = [];
			
			var needleKey = filterKey + '_id';
			$.each($scope.filter.value.superset.value, function(key, value)
			{
				//if all dealers or dealer from this category
				if(value.id == '' || (typeof(value[needleKey]) != 'undefined'))
				{
					subsetValues.push(value);
				}
			});

			//If atleast one dealer found for the filter type
			if(subsetValues.length >1)
			{
				//wait for digest cycle to fix ng-repeat delay issue
				$timeout(function(){
					$scope.subset[filterKey].value = subsetValues;
				}, 10);
			}
		}
		
		//find title for subset
		$scope.subsetTitle[filterKey] = $scope.getSubsetTitle(filterKey, filterValue);
	}
	
	//get title for selected category
	$scope.getSubsetTitle = function(filterKey, filterValue)
	{
		var selectedFilterValue = (typeof (filterValue) == 'undefined' || filterValue == null || filterValue == '' ) ? '' : filterValue;
		var selectedFilterTitle = '';
		
		$.each($scope.filter.value[filterKey].value, function(key, filterItem)
		{
			if(filterItem.id == selectedFilterValue)
			{
				selectedFilterTitle = filterItem.label;
				return false;
			}	
		});
		
		return selectedFilterTitle;
	}
	
	$scope.isActiveFilterType = function(filterKey, filterType)
	{
		if(typeof($scope.appState[filterKey]) != 'undefined' && $scope.appState[filterKey] == filterType)
		{
			return true;
		}	
		
		return false;
	}
	
	//select a filter
	$scope.selectFilter = function(filterKey, filterType, filterValue)
	{
		$scope.currentState[filterKey] = filterType;
		$scope.currentState[filterKey + '_value'] = filterValue;
		
		//If Filter has a superset, select the ShowAll option if nothing is selected from the superset
		if(typeof($scope.filter.value.superset) != 'undefined')
		{	
			//get current superset selection
			var paramName = $scope.filterPopupKey + '_superset_value';
			
			//if the superset selection is not from this subset, select all item from this subset, make currentState dirty
			if(typeof(filterValue) != 'undefined' && filterValue != null && (filterValue == '' || filterValue != '' && jQuery.inArray(filterValue, $scope.noShowAllFilter[filterType]) === -1))
			{
				$scope.currentState[paramName] = '';
				$scope.selectShowAll[filterType] = true;
			}	
			else
			{
				$scope.currentState[paramName] = angular.copy($scope.appState[paramName]);
				$scope.selectShowAll[filterType] = false;
			}
		}
	}
	
	//select a sub filter from superset
	$scope.selectSuperset = function(filterKey, filterType, filterObject)
	{
		//disable selection if it is an inactive user
		if(typeof filterObject.is_active_dealer != 'undefined' && filterObject.is_active_dealer == false)
		{
			return false;
		}
		$scope.currentState[filterKey] = filterType;
		$scope.currentState[filterKey + '_superset_value'] = filterObject.id;
	}
	
	//check if filter is selected
	$scope.isFilterSelected = function(filterKey, filterType, filterValue, mode)
	{
		
		if(typeof($scope.appState[filterKey]) != 'undefined')
		{
			//select all, if selected filter is different and if the tabs are same
			if($scope.appState[filterKey] != filterType && filterValue == '')
			{
				//show tick only if if this is the current tabe
				if(typeof(mode) != 'undefined' && mode == 'lastSelect')
				{
					if(typeof($scope.activeTab) != 'undefined' && $scope.activeTab == filterType)
					{
						return true;
					}	
				}	
				else
				{
					return true;
				}
			}	

			if(typeof(mode) == 'undefined' || mode != 'lastSelect')
			{
				//check the current state if a new filter was selected
				if($scope.currentState[filterKey] == filterType)
				{
					if(typeof($scope.currentState[filterKey + '_value']) != 'undefined')
					{
						if($scope.currentState[filterKey + '_value'] == filterValue)
						{
							return true;
						}	
					}	
				}
			}
			else
			{
				//select corresponding filter value, if selected filter is same
				if($scope.appState[filterKey] == filterType)
				{
					if(typeof($scope.appState[filterKey + '_value']) != 'undefined')
					{
						if($scope.appState[filterKey + '_value'] == filterValue)
						{
							return true;
						}	
					}	
				}
			}
			
				
		}	
		
		return false;
	}
	
	//check if sub filter in superset is selected
	$scope.isSupersetSelected = function(filterKey, supersetItem, filterType)
	{   
		
		var currentSupersetValue = typeof($scope.appState[filterKey + '_superset_value']) != 'undefined' ? $scope.appState[filterKey + '_superset_value'] : null;
		var currentFilterValue = typeof($scope.appState[filterKey + '_value']) != 'undefined' ? $scope.appState[filterKey + '_value'] : null;
		var currentFilterName = typeof($scope.appState[filterKey]) != 'undefined' ? $scope.appState[filterKey] : null;
		
		//when no super set is selected
		if(currentSupersetValue == supersetItem.id && currentFilterName == filterType && $scope.currentFilterId == currentFilterValue && $scope.activeTab == filterType)
		{
			return true;
		}	
		
		return false;
	}
	
	$scope.isShowAllSelected = function(supersetItem, filterKey)
	{
		if($scope.activeTab != filterKey && supersetItem.id == '')
		{
			return true;
		}	
		
		var currentSupersetValue = typeof($scope.appState[$scope.filterPopupKey + '_superset_value']) != 'undefined' ? $scope.appState[$scope.filterPopupKey + '_superset_value'] : null;
		if(currentSupersetValue == '' && supersetItem.id == '')
		{
			return true;
		}	
		
		//if this is not a showAll item, return false
		if(supersetItem.id == '' && typeof($scope.selectShowAll[filterKey]) != 'undefined' && $scope.selectShowAll[filterKey] == true)
		{
			return true;
		}	
		
		return false;
	}
	
	$scope.resetContent = function(filterItem)
	{
		//TODO remove the user selected items and change it back to the default selection when switching betwwen tabs (region, category etc)
		var paramName = $scope.filterPopupKey;
		var newName = '';
		var newValue = '';
		var supersetValue = '';
		
		if($scope.activeTab != filterItem.type)
		{
			newName = filterItem.type;
			newValue = '';
			if(typeof filterItem.value != undefined && filterItem.value.length == 1)
			{
				singleValue = filterItem.value[0];
				if(typeof singleValue.id != undefined && singleValue.id != '')
				{
					newValue = singleValue.id;
					$scope.filterSuperset(filterItem.type, newValue);
				}
			}
			supersetValue = '';
			
		}	
		else
		{
			newName = angular.copy($scope.appState[paramName]);
			newValue = angular.copy($scope.appState[paramName + '_value']);
			supersetValue = angular.copy($scope.appState[paramName + '_superset_value']);;
		}	
		
		$timeout(function(){
			$scope.currentState[paramName] = newName;
			$scope.currentState[paramName + '_value'] = newValue;
			$scope.currentState[paramName + '_superset_value'] = supersetValue;
		}, 10);
	}
	
	$scope.updateNoShowAllFilter = function(filterKey)
	{
		//reset
		$scope.noShowAllFilter[filterKey] = [];
		
		var filterTypeId = filterKey + '_id';
		
		//get current superset selection
		var currentSupersetValue = '';
		var paramName = $scope.filterPopupKey + '_superset_value';
		if(typeof($scope.appState[paramName]) != 'undefined')
		{
			currentSupersetValue = $scope.appState[paramName];
		}
		
		if(currentSupersetValue != '')
		{	
			$.each($scope.filter.value.superset.value, function(key, value)
			{
				//if a superset is selected from this subset, don't select showall item
				if(value.id != '' && value.id == currentSupersetValue)
				{
					$scope.noShowAllFilter[filterKey].push(value[filterTypeId]);
				}
			});
		}
		
	}
	
    $scope.ok = function() 
    {
    	//copy currentState to appState to invoke watch on appState
    	$.each($scope.currentState, function(key, value)
    	{
    		if(typeof($scope.filters[key]) != 'undefined')
    		{
    			if(typeof($scope.filters[key]['remove_selected_filter']) != 'undefined')
    			{
    				$.each($scope.filters[key]['remove_selected_filter'], function(selected_key, selected_filter)
    				{
    					if(typeof($scope.currentState[selected_filter+'_value']) != 'undefined' && $scope.currentState[selected_filter+'_value'] != '')
    					{
							value = '';
							return false;
    					}
    					if(typeof($scope.currentState[selected_filter+'_superset_value']) != 'undefined' && $scope.currentState[selected_filter+'_superset_value'] != '')
    					{
							value = '';
							return false;
    					}
    				});
    			}
    		}
    		$scope.appState[key] = value;
    	});
    	 
        $modalInstance.close();
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
		
	$scope.is_active_between_range = function(active_from_date, inactive_from_date, reference_date_start, reference_date_end)
	{
		if(active_from_date == 0 && inactive_from_date == 0) 
		return true; 
		
		if(active_from_date != 0)
		{
			if(active_from_date > reference_date_end)
			{
				return false;
			}
		}
		
		if(inactive_from_date != 0)
		{
			if(inactive_from_date <= reference_date_start)
			{
				return false;
			}
		}
		return true;
	};
    
    //-------------------------END FUNCTIONS---------------------//
    //-------------------------START HIERARCHY FUNCTIONS---------//
	$scope.onNodeClickFn = function(node, parent) {
		$scope.filterHierarchySuperset(node.type, node.id, parent.type, parent.id);
		$scope.selectFilter($scope.filterPopupKey, node.type, node.id);
		$scope.updateParallelFilterList(node, parent);
    };
	$scope.onTabClickFn = function(filterItem) {
		var paramName = $scope.filterPopupKey;
		var newName = '';
		var newValue = '';
		var supersetValue = '';
		
		if(typeof filterItem.type == 'undefined')
		{
			var hierarchy_category = $scope.filter.hierarchy_category;
			filterItem.type = hierarchy_category;
		}
		
		if($scope.activeTab != filterItem.id)
		{
			newName = filterItem.type;
			newValue = filterItem.id;
			supersetValue = '';
			
		}	
		else
		{
			newName = angular.copy($scope.appState[paramName]);
			newValue = angular.copy($scope.appState[paramName + '_value']);
			supersetValue = angular.copy($scope.appState[paramName + '_superset_value']);;
		}	
		
		$timeout(function(){
			$scope.currentState[paramName] = newName;
			$scope.currentState[paramName + '_value'] = newValue;
			$scope.currentState[paramName + '_superset_value'] = supersetValue;
		}, 10);
    };
	//check if filter is selected
	$scope.checkFilterSelected = function(filterKey, filterType, filterValue)
	{
		if(typeof($scope.appState[filterKey]) != 'undefined')
		{			
			//select corresponding filter value, if selected filter is same
			if($scope.appState[filterKey] == filterType)
			{
				if(typeof($scope.appState[filterKey + '_value']) != 'undefined')
				{
					if($scope.appState[filterKey + '_value'] == filterValue)
					{
						return true;
					}
				}
			}
			
		}
		
		return false;
	}
	$scope.isCurrentFilterSelected = function(filterType, filterValue)
	{
		var currentFilterType = (typeof ($scope.currentState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.currentState[$scope.filterPopupKey];
		var currentFilterValue = (typeof ($scope.currentState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.currentState[$scope.filterPopupKey + '_value'];
		
		if(currentFilterType == filterType && currentFilterValue == filterValue)
		{
			return true;
		}
		return false;
	};
	
	$scope.isItemSelected = function(node, parent, mode) {
		return $scope.isHierarchyFilterSelected(parent, $scope.filterPopupKey, node.type, node.id, mode);
    };
	
	var nodeRecursiveLookup = function(tree, filterKey, filterValue)
	{
		var result = false;
		
		if(tree.id == filterValue && tree.type == filterKey  && typeof tree.id != 'undefined' && typeof tree.type != 'undefined')
		{
			return tree;
		}
		else
		{
			$.each(tree.parallel_filter, function(key, value)
			{
				if(value.id == filterValue && value.type == filterKey  && typeof value.id != 'undefined' && typeof value.type != 'undefined')
				{
					result =  value;
					result.parent_node = tree;
 					return false;
				}
			});
			
			if(result){
				return result;
			}
		}
		
		if(typeof tree.value != 'undefined')
		{
			$.each(tree.value, function(key, value)
			{
				var node = nodeRecursiveLookup(value, filterKey, filterValue);
				if(node)
				{
					result = node;
					return false;
				}
			});

			return result;
		}	
	}
	$scope.isHierarchyFilterSelected = function(filterItem, filterKey, filterType, filterValue, mode)
	{
		var active_node = false;
		
		//If the filter value is empty (All filter), find all child items & check if any of them is selected
		//get filter type and filter value
		var selectedFilterType = (typeof ($scope.appState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey];
		var selectedFilterValue = (typeof ($scope.appState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey + '_value'];
		
		var currentFilterType = (typeof ($scope.currentState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.currentState[$scope.filterPopupKey];
		var currentFilterValue = (typeof ($scope.currentState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.currentState[$scope.filterPopupKey + '_value'];
		
		if(filterValue == '')
		{
			//loop through all child elements recursively & find if any of them are selected
			$.each(filterItem.value, function(key, childFilter)
			{
				if(childFilter.id)
				{
					childFilterValue = childFilter.id;
					
					//loop through all child elements recursively & find if any of them are selected
					active_node = nodeRecursiveLookup(childFilter, selectedFilterType, selectedFilterValue);
					if(active_node)
					{
						return false;
					}
				}
			});
		}
		
		//check active state for the filter item
		var get_active_node = nodeRecursiveLookup(filterItem, selectedFilterType, selectedFilterValue);
		if(typeof get_active_node.parent_node != 'undefined')
		{
			//if brand selected
			var parent_node = get_active_node.parent_node;
			if(filterValue == parent_node.id)
			{
				active_node = parent_node;
				if(typeof(mode) != 'undefined' && mode == 'lastSelect')
				{
					return true;
				}
			}
		}
		
		//check current state for the filter item
		var get_current_node = nodeRecursiveLookup(filterItem, currentFilterType, currentFilterValue);
		if(typeof get_current_node.parent_node != 'undefined')
		{
			//if brand selected
			var parent_node = get_current_node.parent_node;
			if(filterValue == parent_node.id)
			{
				// active_node = parent_node;
				if(typeof(mode) == 'undefined' || mode != 'lastSelect')
				{
					return true;
				}
			}
		}
				
		//check the active node for a match
		if(typeof($scope.appState[filterKey]) != 'undefined')
		{
			//select all, if selected filter is different and if the tabs are same & no active children are present
			if($scope.appState[filterKey] != filterType && filterValue == '' && !active_node)
			{
				//show tick only if if this is the current tab
				if(typeof(mode) != 'undefined' && mode == 'lastSelect')
				{
					if(typeof($scope.activeTab) != 'undefined' && $scope.activeTab == filterValue)
					{
						return true;
					}	
				}	
				else
				{	
					return true;
				}
			}	
			
			//select corresponding filter value, if selected filter is same
			if($scope.currentState[filterKey] == filterType && !(typeof(mode) != 'undefined' && mode == 'lastSelect'))
			{
				if(typeof($scope.currentState[filterKey + '_value']) != 'undefined')
				{
					if($scope.currentState[filterKey + '_value'] == filterValue)
					{
						return true;
					}	
				}	
			}
			else if($scope.appState[filterKey] == filterType && !($scope.currentState[filterKey] != '' && $scope.currentState[filterKey] != filterType && !(typeof(mode) != 'undefined' && mode == 'lastSelect')))
			{
				if(typeof($scope.appState[filterKey + '_value']) != 'undefined')
				{
					if($scope.appState[filterKey + '_value'] == filterValue)
					{
						return true;
					}	
				}	
			}
			
		}
		
		return false;
	}
	//check if sub filter in superset is selected
	$scope.isHierarchySupersetSelected = function(filterKey, supersetItem, filterType, filterValue)
	{   
		var currentSupersetValue = typeof($scope.appState[filterKey + '_superset_value']) != 'undefined' ? $scope.appState[filterKey + '_superset_value'] : null;
		var currentFilterValue = typeof($scope.appState[filterKey + '_value']) != 'undefined' ? $scope.appState[filterKey + '_value'] : null;
		var currentFilterName = typeof($scope.appState[filterKey]) != 'undefined' ? $scope.appState[filterKey] : null;
		
		//when no super set is selected
		if(currentSupersetValue == supersetItem.id && $scope.currentFilterId == currentFilterValue && $scope.activeTab == filterValue)
		{
			return true;
		}	
		
		return false;
	}
	$scope.isCurrentSupersetSelected = function(supersetItem)
	{
		var selectedFilterType = (typeof ($scope.appState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey];
		var selectedFilterValue = (typeof ($scope.appState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey + '_value'];
		var selectedSupersetValue = typeof($scope.appState[$scope.filterPopupKey + '_superset_value']) != 'undefined' ? $scope.appState[$scope.filterPopupKey + '_superset_value'] : null;
		
		var currentFilterType = (typeof ($scope.currentState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.currentState[$scope.filterPopupKey];
		var currentFilterValue = (typeof ($scope.currentState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.currentState[$scope.filterPopupKey + '_value'];
		var currentSupersetValue = typeof($scope.currentState[$scope.filterPopupKey + '_superset_value']) != 'undefined' ? $scope.currentState[$scope.filterPopupKey + '_superset_value'] : null;
		
		if(selectedFilterType == currentFilterType && selectedFilterValue == currentFilterValue)
		{
			if(supersetItem.id == currentSupersetValue)
			{
				return true;
			}
		}
		else if(supersetItem.id == currentSupersetValue)
		{
			return true;
		}
		
		return false;
	};
	//filter the superset hierarchy based on the category selected
	$scope.filterHierarchySuperset = function(filterKey, filterValue, parentFilterKey, parentFilterValue)
	{
		//show full set when filterValue is null
		// $scope.hierarchy_subset[parentFilterValue] = angular.copy($scope.filter.value.superset);
		if(typeof(filterValue) == 'undefined' || filterValue == null || filterValue == '')
		{	
			//store new values
			var subsetValues = [];
			
			var needleKey = parentFilterKey + '_id';
			$.each($scope.filter.value.superset.value, function(key, value)
			{
				//if all dealers or dealer from this category
				if(value.id == '' || (typeof(value[needleKey]) != 'undefined' && value[needleKey] == parentFilterValue) || typeof(parentFilterValue) == 'undefined' || parentFilterValue == '')
				{
					subsetValues.push(value);
				}
			});
			
			//wait for digest cycle to fix ng-repeat delay issue
			$timeout(function(){
				$scope.hierarchy_subset[parentFilterValue] = {};
				$scope.hierarchy_subset[parentFilterValue].value = subsetValues;
			}, 10);
			
			//find title for subset
			$scope.subsetTitle[parentFilterValue] = $scope.getSubsetTitle(parentFilterKey, parentFilterValue);
		}
		
		if(filterValue != null)
		{	
			$timeout(function(){
				$scope.currentFilterId = filterValue;
			}, 10);
		}
				
		//if filterValue is found, filter items to that filter type
		if(typeof(filterValue) != 'undefined' && filterValue != null && filterValue != '')
		{	
			//store new values
			var subsetValues = [];
			
			var needleKey = filterKey + '_id';
			$.each($scope.filter.value.superset.value, function(key, value)
			{
				//if all dealers or dealer from this category
				if(value.id == '' || (typeof(value[needleKey]) != 'undefined' && value[needleKey] == filterValue))
				{
					subsetValues.push(value);
				}
			});
			
			//wait for digest cycle to fix ng-repeat delay issue
			$timeout(function(){
				$scope.hierarchy_subset[parentFilterValue] = {};
				$scope.hierarchy_subset[parentFilterValue].value = subsetValues;
			}, 10);
			
			//find title for subset
			$scope.subsetTitle[parentFilterValue] = $scope.getSubsetTitle(filterKey, filterValue);
		}
	}
	//select a sub filter from superset
	$scope.selectHierarchySuperset = function(filterKey, filterType, filterObject)
	{
		//disable selection if it is an inactive user
		if(typeof filterObject.is_active_dealer != 'undefined' && filterObject.is_active_dealer == false)
		{
			return false;
		}
		$scope.currentState[filterKey + '_superset_value'] = filterObject.id;
	}
	$scope.updateParallelFilterList = function(node, parent, skip_all_label)
	{
		skip_all_label = skip_all_label == true?true:false;
		var filterlist = typeof node.parallel_filter != 'undefined'? node.parallel_filter : {};
		var parentFilterKey = parent.type;
		var parentFilterValue = parent.id;
		var parallel_category_label = typeof $scope.filter.parallel_category_label != 'undefined'?$scope.filter.parallel_category_label:'All Brands';

		var newfilterlist = [];

		if(!skip_all_label)
		{
			var first_item = angular.copy(node);
			first_item.label = parallel_category_label+" - "+node.label;
			newfilterlist.push(first_item);
		}
		
		$.each(filterlist, function(key, value){
			newfilterlist.push(value);
		});

		$scope.parallel_filter_items[parentFilterValue] = newfilterlist;
		$scope.selected_parallel_filter[parentFilterValue] = newfilterlist[0].label;
	}
	$scope.selectParallelFilter = function(subfilter, filterItem, filterPopupKey)
	{
		$scope.filterHierarchySuperset(subfilter.type, subfilter.id, filterItem.type, filterItem.id);
		$scope.selectFilter(filterPopupKey, subfilter.type, subfilter.id);
		$scope.selected_parallel_filter[filterItem.id] = subfilter.label;
	}
	$scope.selectGenericFilter = function(subfilter, filterItem, filterPopupKey)
	{
		// $scope.filterHierarchySuperset(subfilter.type, subfilter.id, filterItem.type, filterItem.id);
		$scope.selectFilter(filterPopupKey, subfilter.type, subfilter.id);
		
		if(subfilter.id == "")
		{
			var newfilterlist = [];
			$.each($scope.filter.value[hierarchy_category].value, function(key, value){
				if(typeof value.type == 'undefined' || value.type == "")
				{
					value.type = hierarchy_category;
				}
				newfilterlist.push(value);
			});
			
			$scope.hierarchy_generic_category_items = newfilterlist;
		}
		else
		{
			var newfilterlist = [];
			newfilterlist.push(subfilter);
			$.each(subfilter.parallel_filter, function(key, value){
				newfilterlist.push(value);
			});
			
			$scope.hierarchy_generic_category_items = newfilterlist;
		}
		
		$scope.selected_parallel_filter[filterItem.id] = subfilter.label;
	}
	$scope.resetTab = function(filterItem, filterPopupKey)
	{
		//update noShowAllFilter for this filter Type
		$scope.updateNoShowAllFilter(filterItem.type);

		var selectedFilterType = (typeof ($scope.appState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey];
		var selectedFilterValue = (typeof ($scope.appState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey + '_value'];
		
		var active_node = nodeRecursiveLookup(filterItem, selectedFilterType, selectedFilterValue);
		if(active_node)
		{
			var parent_node = typeof active_node.parent_node != 'undefined'?active_node.parent_node:null;
			if(parent_node)
			{
				$scope.filterHierarchySuperset(active_node.type, active_node.id, filterItem.type, filterItem.id);
				$scope.updateParallelFilterList(parent_node, filterItem);
				$scope.selected_parallel_filter[filterItem.id] = active_node.label;
				
				if(filterItem.id == "")
				{
					$scope.selectGenericFilter(active_node, parent_node, filterPopupKey);
				}
			}
			else
			{
				$scope.filterHierarchySuperset(active_node.type, active_node.id, filterItem.type, filterItem.id);
				$scope.updateParallelFilterList(active_node, filterItem);
				if(filterItem.id =="")
				{
					$scope.selectGenericFilter(filterItem, filterItem, filterPopupKey);
				}
			}
			// $scope.filter.value[hierarchy_category].value[key].active = true;
			// $scope.activeTab = filterItem.id;
		}
		else
		{
			$scope.selectFilter(filterPopupKey, filterItem.type, filterItem.id);
			// $scope.filterHierarchySuperset(filterItem.type, filterItem.id, filterItem.type, filterItem.id);
			$scope.filterHierarchySuperset(null, null, filterItem.type, filterItem.id);
			$scope.updateParallelFilterList(filterItem, filterItem);
			
			if(filterItem.id =="")
			{
				$scope.selectGenericFilter(filterItem, filterItem, filterPopupKey);
			}
		}
	}
    //-------------------------END HIERARCHY FUNCTIONS-----------//
    
	//modify admin_site filters to verify if they are active or inactive
	if($scope.filterPopupKey == 'admin_site')
	{
		var submitTime = $scope.appState['submit_time'];
		var submitTimeValue = $scope.appState['submit_time_value'];
		var time_from = '';
		var time_to = '';
		$scope.time_filter = angular.copy($scope.$parent.$parent.filters['submit_time']);
		$.each($scope.time_filter.value, function(filterKey, filterItem)
		{
			//if selected item found
			if(filterKey == submitTime)
			{
				$.each(filterItem.value, function(itemKey, itemValue)
				{
					if(itemKey == submitTimeValue)
					{
						time_from = itemValue.from;
						time_to = itemValue.to;
						return true;
					}
				});
				return true;
			}
		});
		
		$.each($scope.filter.value, function(filterKey, filterItem)
		{
			//if superset, chech if the dealer is till active
			if(filterKey == 'superset')
			{
				$.each(filterItem.value, function(itemKey, itemValue)
				{
					//check filter
					var active_from_date = typeof itemValue.active_from_date != 'undefined'?itemValue.active_from_date:'';
					var inactive_from_date = typeof itemValue.inactive_from_date != 'undefined'?itemValue.inactive_from_date:'';
					var is_active_dealer = $scope.is_active_between_range(active_from_date, inactive_from_date, time_from, time_to);
					if(is_active_dealer == true)
					{
						$scope.filter.value[filterKey].value[itemKey].is_active_dealer = true;
					}
					else {
						$scope.filter.value[filterKey].value[itemKey].is_active_dealer = false;
					}
				});
			}
		});
	}
		
    //add active property to filters to mark active tab
	$.each($scope.filter.value, function(filterKey, filterItem)
	{
		//skip superset
		if(filterKey == 'superset')
		{
			return true;
		}
			
		if(typeof($scope.appState[$scope.filterPopupKey]) != 'undefined' && $scope.appState[$scope.filterPopupKey] == filterKey)
    	{
    		$scope.filter.value[filterKey].active = true;
    	}
    	else
    	{
    		$scope.filter.value[filterKey].active = false;
    	}	
    });
	
    
	//check if filter hierarchy is defined
	var hierarchy_category = $scope.filter.hierarchy_category;
	
	if(hierarchy_category)
	{
		//get filter type and filter value
		var selectedFilterType = (typeof ($scope.appState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey];
		var selectedFilterValue = (typeof ($scope.appState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey + '_value'];
		
		var parallel_category = $scope.filter.parallel_category;
		var parallel_filter_node = typeof $scope.filter.value[parallel_category] != 'undefined'?$scope.filter.value[parallel_category]: null;
		
		var parallel_filter_values = [];
		if(parallel_filter_node && typeof parallel_filter_node.value != 'undefined')
		{
			$.each(parallel_filter_node.value, function(key, value)
			{
				if(value.id != "")
				{
					parallel_filter_values.push(value);
				}
			});
		}

		var newfilterlist = [];
		$.each($scope.filter.value[hierarchy_category].value, function(key, value){
			if(typeof value.type == 'undefined' || value.type == "")
			{
				value.type = hierarchy_category;
			}
			newfilterlist.push(value);
		});
		
		$scope.hierarchy_generic_category_items = newfilterlist;
		
		$.each($scope.filter.value, function(filterKey, filterValue)
		{			
			//skip superset
			if(filterKey != hierarchy_category)
			{
				return true;
			}	
			$.each(filterValue.value, function(key, childFilter)
			{
				childFilterValue = childFilter.id;
				
				//If Global
				if(childFilterValue == "")
				{
					//Add the parallel filters
					$scope.filter.value[hierarchy_category].value[key].parallel_filter = parallel_filter_values;
				}
				
				//update noShowAllFilter for this filter Type
				$scope.updateNoShowAllFilter(filterKey);

				//loop through all child elements recursively & find if any of them are selected
				var active_node = nodeRecursiveLookup(childFilter, selectedFilterType, selectedFilterValue);
				if(active_node)
				{
					var parent_node = typeof active_node.parent_node != 'undefined'?active_node.parent_node:null;
					if(parent_node)
					{
						$scope.filterHierarchySuperset(active_node.type, active_node.id, filterKey, childFilterValue);
						$scope.updateParallelFilterList(parent_node, childFilter);
						$scope.selected_parallel_filter[childFilterValue] = active_node.label;
						
						if(childFilterValue == "")
						{
							$scope.selectGenericFilter(active_node, parent_node, $scope.filterPopupKey);
						}
					}
					else
					{
						$scope.filterHierarchySuperset(active_node.type, active_node.id, filterKey, childFilterValue);
						$scope.updateParallelFilterList(active_node, childFilter);
					}
					$scope.filter.value[hierarchy_category].value[key].active = true;
					$scope.activeTab = childFilterValue;
				}
				else
				{
					$scope.filterHierarchySuperset(null, null, filterKey, childFilterValue);
					$scope.updateParallelFilterList(childFilter, childFilter);
				}
			});
			
		});
	}
	else
	{
	    //create subset from superset for display
		if(typeof($scope.filter.value.superset) != 'undefined')
		{
			//get filter type and filter value
			var selectedFilterType = (typeof ($scope.appState[$scope.filterPopupKey]) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey];
			var selectedFilterValue = (typeof ($scope.appState[$scope.filterPopupKey + '_value']) == 'undefined') ? '' : $scope.appState[$scope.filterPopupKey + '_value'];

			$.each($scope.filter.value, function(filterKey, filterValue)
			{
				//skip superset
				if(filterKey == 'superset')
				{
					return true;
				}	
				
				//update noShowAllFilter for this filter Type
				$scope.updateNoShowAllFilter(filterKey);
				
				
				//if filterKey is same as selectedFilterType, filter the subset
				if(filterKey == selectedFilterType)
				{	
					$scope.filterSuperset(filterKey, selectedFilterValue);
					$scope.activeTab = filterKey;
				}
				else
				{
					$scope.filterSuperset(filterKey, null);
				}	
			});
		}
	}
};

// app.controller('rightSideController', function($http, $scope, $stateParams, $state, $location, dataService, $rootScope, appService, $q, $timeout, $window, appActivity, httpPendingRequests, $controller, sidebarConfig, pageHandler) {
app.controller('rightSideController', function($http, $scope, $rootScope, $stateParams, $location, dataService, DTColumnBuilder, sidebarConfig, pageHandler, $q, $timeout, $controller) {

	var currentState = angular.copy($scope.$parent.$parent.appState);
	currentState.page = 'right_sidebar';

	//set the page filters
	var sidebar_page_filters = angular.copy(sidebarConfig.filters);
	var sidebar_state_page_filters = {};
	if(typeof  sidebar_page_filters != 'undefined'){
        angular.forEach(sidebar_page_filters, function(item, itemKey){
            sidebar_state_page_filters[itemKey] = typeof item.selected_value != 'undefined'? item.selected_value:'';
        });
	}
	currentState.page_filters = sidebar_state_page_filters;
	
	$scope.appState = currentState;
	$scope.sidebar_config = $scope.$parent.$parent.right_sidebar;
	$scope.rightSidebarTitle = $scope.sidebar_config.title;
	
	//initialise survey specific views
	pageHandler.initViews(sidebarConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(sidebarConfig, $scope);

	if(filtersLoaded)
	{
		//initialise components
		pageHandler.initComponents(sidebarConfig, $scope);

		//show loading on components
		pageHandler.showLoading(sidebarConfig, $scope);

		//request data for components
		pageHandler.requestDataForComponents(sidebarConfig, $scope);
	}


	//===================================== Sidebar functions =============================================

	//capture experience change triggered
	$scope.$on('changeSidebarEvent', function(event, args) {
		// console.log("change right sidebar");
		$scope.changeSidebar(args);
	});

	$scope.updateSidebar = function(newState)
	{
		var responseData = {};
		var deferred = $q.defer();

		//get available options and selected_value for new state
		dataService.getData('common/init_sidebar', {'app_state' : newState} , 'POST', false)
			.then(function(response) {
				if(typeof(response.data) != 'undefined')
				{
					responseData = response.data;					
					deferred.resolve(responseData);
				}
			}
		);
		return deferred.promise;
	}

	$scope.changeSidebar = function(args)
	{
		//Request components of right sidebar
		var newState = angular.copy(args);

		//check if this is an update request from within the sidebar scope or from the page scope
        if(typeof $scope.locationChangeInitiator != 'undefined' && $scope.locationChangeInitiator == 'sidebar')
        {
            //Do nothing
            $scope.locationChangeInitiator = false;
        }
        else
        {
            //modify the page
            newState.page = 'right_sidebar';
            //todo: modify the filters
            newState.page_filters = {};
		}

		var oldState = null;
		if(typeof $rootScope.previousState != 'undefined')
		{
			oldState = angular.copy($rootScope.previousState);
		}

		//Verify change in state
		if(oldState != newState && oldState != null)
		{
			//verify if this change is valid
			oldState.page = 'right_sidebar';
			oldState.page_filters = {};

			if(angular.equals(oldState, newState))
			{
				// console.log("Dont update the sidebar");
				return false;
			}
		}

		//Update the sidebar
		$scope.updateSidebar(newState).then(function(responseData) 
		{
            //set the page filters
            var sidebar_page_filters = angular.copy(responseData.filters);
            var sidebar_state_page_filters = {};
            if(typeof  sidebar_page_filters != 'undefined'){
                angular.forEach(sidebar_page_filters, function(item, itemKey){
                	if(typeof newState.page_filters != 'undefined' && typeof newState.page_filters[itemKey] != 'undefined')
                	{
                        sidebar_state_page_filters[itemKey] = newState.page_filters[itemKey]; // Leave it as it is
					}
					else
					{
						sidebar_state_page_filters[itemKey] = typeof item.selected_value != 'undefined'? item.selected_value:'';
					}

                });
            }
            newState.page_filters = sidebar_state_page_filters;

			$scope.appState = newState;
			$scope.sidebar_config = $rootScope.right_sidebar;
			$scope.rightSidebarTitle = $scope.sidebar_config.title;

			//initialise survey specific views
			pageHandler.initViews(responseData, $scope);

			//initialise filters
			var filtersLoaded = pageHandler.initFilters(responseData, $scope);
			if(filtersLoaded)
			{
				//initialise components
				pageHandler.initComponents(responseData, $scope);

				//show loading on components
				pageHandler.showLoading(responseData, $scope);

				//request data for components
				pageHandler.requestDataForComponents(responseData, $scope);
			}
		});
	}

    $scope.$watch('appState.page_filters', function(newVal, oldVal)
	{
        if(newVal !== oldVal)
        {
            //check if the appState was already validated
            // if(typeof $scope.appStateValidated == 'undefined' || $scope.appStateValidated == false)
            // {
                //set locationChangeInitiator as initiated by appState
                $scope.locationChangeInitiator = 'sidebar';

                //validate new state
                $scope.changeSidebar($scope.appState);

				//record the validation to avoid duplicate validation
				$scope.appStateValidated = true;

           /* }
            else
            {
                $scope.appStateValidated = false;
            }*/
        }
    }, true);

	
	//Verify the sidebar's visibility
	$scope.isSidebarVisible = function()
	{
		var app_state = angular.copy($rootScope.appState);
		var active_page = typeof app_state.page != undefined ? app_state.page: '';
		$scope.rightSidebarAllowedPages = typeof $scope.sidebar_config.available_for != 'undefined' ? angular.copy($scope.sidebar_config.available_for) : {};

		if(!angular.equals({}, $scope.rightSidebarAllowedPages))
		{
			if($scope.rightSidebarAllowedPages.indexOf(active_page) != -1)
			{
				//Allowed
				return true;
			}
		}
		return false;
	}
	
});

app.controller('footerController', function($http, $scope, $stateParams, $location, dataService) {
	
});
